import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableSummary } from 'src/app/models/period-aggregate-amounts.model'
import {
  getUdiscoverPageviews,
  getLoading,
} from 'src/app/selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByUdiscoverPageviews,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-udiscover-pageview',
    templateUrl: './aggregated-amounts-udiscover-pageview.component.html',
    styleUrls: ['./aggregated-amounts-udiscover-pageview.component.scss'],
    standalone: false
})
export class AggregatedAmountsUdiscoverPageviewComponent implements OnInit {
  udiscoverPageviewModel$: Observable<CountableSummary>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.udiscoverPageviewModel$ = this.store.select(getUdiscoverPageviews)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByUdiscoverPageviews)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
